export { default as default } from './modules/read/readXlsxFileBrowser'
export { default as readSheetNames } from './modules/read/readSheetNamesBrowser'
export { default as parseExcelDate } from './modules/read/parseDate'
export { default as Integer } from './modules/types/Integer'
export { default as Email } from './modules/types/Email'
export { default as URL } from './modules/types/URL'



//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/index.js
// module id = 386
// module chunks = 1